var app = angular.module('leonardo');

var WPFormDateNew = function (FilterService, $timeout, AuthDataService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      inline: '@',
      timeZone: '@',
      placeholder: '@',
      startDate: '@',
      endDate: '@',
      filter: '@',
      ngChange: '&',
      format: '@',
      name: '@',
      dateNoFuture: '@'
    },
    templateUrl: 'views/templates/form/form-date.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.country = AuthDataService.authData && AuthDataService.authData.account ? angular.copy(AuthDataService.authData.account.country) : null;
      scope.defaultDateMask = scope.country && scope.country.date_mask ? scope.country.date_mask.toString() : 'MM-DD-YYYY';
      scope.$input = attrs.inline ? element.find('.form-date-inline-widget') : element.find('.form-date-input');
      scope.date = '';
      scope.init = false;
      scope.removeYear = attrs.headerFormat ? !attrs.headerFormat.toLowerCase().includes('y') : false;
      scope.removeMonth = attrs.headerFormat ? !attrs.headerFormat.toLowerCase().includes('m') : false;
      scope.timeZone = scope.timeZone || jstz.determine().name();

      scope.getMask = function () {
        var result = scope.format ? angular.copy(scope.format) : angular.copy(scope.defaultDateMask);
        if (!isNull(result)) {
          result = result.toString();
          result = result.replaceAll('M', '9');
          result = result.replaceAll('D', '9');
          result = result.replaceAll('Y', '9');
        } else {
          result = '99-99-9999';
        }
        return result;
      };

      scope.mask = scope.mask ? scope.mask : scope.getMask();

      if (!scope.inline) {
        angular.element(scope.$input).mask(scope.mask);
      }

      var options = {
        format: scope.format || scope.defaultDateMask,
        locale: 'en',
        widgetPositioning: {
          horizontal: attrs.positionHorizontal ? attrs.positionHorizontal : 'left',
          vertical: attrs.positionVertical ? attrs.positionVertical : 'top'
        },
        useCurrent: false,
        keepOpen: attrs.notAutoclose ? true : false,
        dayViewHeaderFormat: attrs.headerFormat || 'MMMM YYYY',
        showTodayButton: attrs.hideToday ? false : true,
        timeZone: scope.timeZone,
        viewMode: attrs.viewMode || 'days'
      };

      scope.ngModelCtrl.$render = function () {
        scope.date = scope.ngModelCtrl.$modelValue;
        if (scope.filter) {
          scope.date = FilterService.getFilter(scope.filter);
        }
      };

      scope.$input.datetimepicker2(options);

      if (scope.disabled) {
        scope.$input.data('DateTimePicker').disable();
      }

      scope.$input.datetimepicker2().on('dp.change', function (e) {
        if (e.date) {
          var value = moment(e.date).format("YYYY-MM-DD");
          if (scope.format && scope.format === "MM-DD") {
            value = moment(e.date).format("MM-DD");
          }
          scope.date = value;
          if (scope.filter) {
            FilterService.setFilter(scope.filter, value);
          }
        } else {
          scope.date = '';
          if (scope.filter) {
            FilterService.removeFilter(scope.filter);
          }
        }
        scope.$input.data('DateTimePicker').hide();
        scope.ngModelCtrl.$setViewValue(scope.date);
        scope.ngChange();
      });

      scope.$input.datetimepicker2().on('clearDate', function (e) {
        scope.ngModelCtrl.$setViewValue(null);
        if (scope.filter) {
          FilterService.removeFilter(scope.filter);
        }
      });

      scope.getDate = function (option) {
        let date;
        switch (option) {
          case 'today':
            date = moment();
            break;
          case 'yesterday':
            date = moment().subtract(1, 'days');
            break;
          case 'tomorrow':
            date = moment().add(1, 'days');
            break;
          default:
            date = moment(option);
            break;
        }
        let dateTimezone = scope.timeZone ? date.tz(scope.timeZone) : date;
        return moment(dateTimezone.format('YYYY-MM-DDTHH:mm:ss'));
      };

      scope.setStartDate = function (startDate) {
        if (startDate && scope.$input.data('DateTimePicker')) {
          var m = scope.getDate(startDate).startOf('d');
          if(m.toDate().toString() !== 'Invalid Date') scope.$input.data('DateTimePicker').minDate(m.toDate());
        } else if (scope.$input.data('DateTimePicker')) {
          scope.$input.data('DateTimePicker').minDate(false);
        }
      };

      scope.setEndDate = function (endDate) {
        if (endDate && scope.$input.data('DateTimePicker')) {
          var m = scope.getDate(endDate).startOf('d');
          if(m.toDate().toString() !== 'Invalid Date') scope.$input.data('DateTimePicker').maxDate(m.toDate());
        } else if (scope.$input.data('DateTimePicker')) {
          if (scope.dateNoFuture) {
            scope.$input.data('DateTimePicker').maxDate(scope.getDate('today').toDate());
          } else {
            scope.$input.data('DateTimePicker').maxDate(false);
          }
        }
      };

      scope.$watch('startDate', function (newValue) {
        $timeout(function () {
          scope.setStartDate(newValue);
        }, 10);
      });

      scope.$watch('endDate', function (newValue) {
        $timeout(function () {
          scope.setEndDate(newValue);
        }, 10);
      });

      scope.$on('filter-date-range:filter-changed', function ($event, key, value, disable) {
        if (key === scope.filter) {
          if (!angular.equals(value, scope.date)) {
            scope.$input.data('DateTimePicker').minDate(false);
            scope.$input.data('DateTimePicker').maxDate(false);
            if (value) {
              scope.date = value;
            } else {
              scope.date = '';
            }
          }
          scope.disable = !!disable;
        }
      });

      scope.$on('value-date-range:status-changed', function ($event, keys, disable) {
        if (_.contains(keys, scope.filter) || _.contains(keys, scope.name)) {
          scope.disable = !!disable;
        }
      });

      scope.$on('filter-service:filter-changed', function ($event, key, value) {
        if (key === scope.filter) {
          if (!angular.equals(value, scope.date)) {
            scope.date = value;
          }
        }
      });

      scope.$on('filter-service:filter-removed', function ($event, key) {
        if (key === scope.filter) {
          scope.date = '';
        }
      });

      scope.$watch('timeZone', function (newValue, oldValue) {
        if (angular.equals(newValue, oldValue)) {
          return;
        }
        if (scope.startDate) {
          scope.setStartDate(scope.startDate);
        }
        if (scope.endDate) {
          scope.setEndDate(scope.endDate);
        }
      });

      scope.$watch('disable', function (newValue) {
        if (scope.disabled) {
          return;
        }
        if (newValue) {
          scope.$input.data('DateTimePicker').disable();
        } else {
          scope.$input.data('DateTimePicker').enable();
        }
      });

      scope.$watch('date', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue) || !scope.init) {
          if (newValue) {
            $timeout(function () {
              if (scope.$input.data('DateTimePicker')) {
                var m = moment(newValue);
                scope.$apply(scope.$input.data('DateTimePicker').date(m.toDate()));
                if (!scope.value) {
                  scope.value = m.format(scope.format || scope.defaultDateMask);
                }
              }
            }, 20);
          } else if (scope.$input.data('DateTimePicker')) {
            scope.$input.data('DateTimePicker').date(null);
          }
          scope.ngModelCtrl.$setViewValue(newValue);
          scope.init = true;
        }
      });

      scope.$on('$destroy', function () {
        scope.$input.data('DateTimePicker').destroy();
      });

      element.find('input').bind('keydown keypress', function (event) {
        if (event.key !== 'Backspace') {
          event.preventDefault();
        } else {
          scope.date = '';
        }
      });
    }
  };
};

app.directive('wpFormDateNew', ['FilterService', '$timeout', 'AuthDataService', WPFormDateNew]);
